import { useState } from 'react';
import { Tab, TabList } from '@fluentui/react-components';
import { PageHeader } from '../components/PageHeader';
import { SoftwareUserTab } from './SoftwareUserTab';
import { SoftwareInventoryTab } from './SoftwareInventoryTab';

type Tabs = 'user' | 'inventory';

export function SoftwarePage() {
  const [tab, setTab] = useState<Tabs>('user');

  return (
    <div>
      <PageHeader
        title="Software"
        description="Intune-Apps über Zuweisungs-Gruppen verwalten und das App-Inventar einsehen."
      />
      <TabList selectedValue={tab} onTabSelect={(_, d) => setTab(d.value as Tabs)} style={{ marginBottom: 16 }}>
        <Tab value="user">User</Tab>
        <Tab value="inventory">Inventory</Tab>
      </TabList>

      {tab === 'user' ? <SoftwareUserTab /> : <SoftwareInventoryTab />}
    </div>
  );
}
